import React from 'react';
import { Button } from './Button';

const InboxIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M2 13l2.5-8h11L18 13H2Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
    <path d="M2 13h4l1.5 2h5l1.5-2H18" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"/>
  </svg>
);

export function EmptyState({ title, message, actionLabel, onAction, icon: Icon = InboxIcon }) {
  return (
    <section className="ui-state" role="status" aria-live="polite">
      <div className="ui-state-icon">
        <Icon />
      </div>
      <h3>{title}</h3>
      {message && <p>{message}</p>}
      {actionLabel && onAction ? (
        <Button variant="secondary" size="sm" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </section>
  );
}
